export function getVideoModuleEntry(child: any) {
  const oneToOne = child?.modules?.ONE_TO_ONE;
  if (!oneToOne) return null;

  if (oneToOne.videoServiceVarients) return oneToOne.videoServiceVarients;
  if (oneToOne.video_service_varients) return oneToOne.video_service_varients;

  for (const key of Object.keys(oneToOne)) {
    const entry = oneToOne[key];
    if (entry?.model === "videoServiceVarients") return entry;
  }

  return null;
}

export function useVideoChildModuleData(child: any) {
  const variantEntry = getVideoModuleEntry(child);

  const serviceName =
    variantEntry?.videoService?.value || variantEntry?.service?.value || "";
  const variantName = variantEntry?.value || "";
  const variantId = variantEntry?.id ?? null;

  return {
    serviceName,
    variantName,
    variantId,
  };
}
